import React from "react";
import { useSelector } from "react-redux";
import TextField from "../../../../../components/input-fields/TextField";

const EmailSection = ({ contact, index, onContactUpdated }) => {
  const { config, contactErrors } = useSelector((state) => state.companyDirectory);

  const emailDestinationIndex = contact.destinations.findIndex((destination) => destination.type === "email");

  const email = emailDestinationIndex !== -1 ? contact.destinations[emailDestinationIndex].value : "";
  const error = contactErrors[index]?.destinations?.[emailDestinationIndex] || "";

  const onEmailUpdated = (value) => {
    var destinations = [...contact.destinations];
    var emailDestinationIndex = destinations.findIndex((destination) => destination.type === "email");

    if (emailDestinationIndex === -1) {
      destinations.push({ type: "email", value: value });
    } else {
      destinations[emailDestinationIndex].value = value;
    }

    onContactUpdated(index, "destinations", destinations);
  };

  return (
    <div className="w-full flex gap-4 justify-center items-center">
      <TextField
        title={"Email"}
        value={email}
        placeholder={"Email"}
        onChange={onEmailUpdated}
        errorMessage={error}
        maxCharacters={config.maxEmailCharacters}
        regexMessage="Only allowed characters are letters, numbers, and @+."
        inputRegex={/^[a-zA-Z\s@+.0-9-]*$/}
        prefixIcon={"/assets/icons/destinations/email.svg"}
        required={contact.isDefault}
      />
    </div>
  );
};

export default EmailSection;
